import React from "react";
import Grid from "@material-ui/core/Grid";
import { Draggable } from "react-beautiful-dnd";
import { makeStyles } from "@material-ui/core/styles";
import style from "../../assets/jss/disal-main/Layouts/Route";
import Checkbox from "@material-ui/core/Checkbox";
import CloseIcon from "@material-ui/icons/Close";

const useStyles = makeStyles(style);

const DAYS_SHORT = ["Lu", "Ma", "Mi", "Ju", "Vi", "Sa", "Do"];

const Task = ({ routeId = "new", val, index, handleChangeCheckNew, handleDelete }) => {
  const classes = useStyles();

  return (
    <Draggable
      draggableId={`${routeId}-${val.collectPointId}`}
      index={index}
    >
      {provided => (
        <Grid
          item
          xs={12}
          className={classes.detailItem}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          ref={provided.innerRef}
        >
          <Grid container>
            <Grid item xs={1}>
              <p>{val.pointNumber}</p>
            </Grid>
            <Grid
              item
              xs={5}
              style={{
                paddingRight: "10px"
              }}
            >
              <p>{val.collectPointName}</p>
            </Grid>
            <Grid
              item
              xs={5}
              style={{
                paddingLeft: "10px"
              }}
            >
              <Grid style={{ display: "flex", justifyContent: "flex-end" }}>
                {DAYS_SHORT.map((dayShort, dayIndex) => (
                  <Grid key={dayIndex} className={classes.contentCheckBox}>
                    <Grid>
                      <Grid>{dayShort}</Grid>
                      <Grid>
                        <Checkbox
                          name={`${index}-${dayIndex}`}
                          id={`${index}-${dayIndex}`}
                          checked={val.days[dayIndex].checked || false}
                          className={classes.checkBox}
                          onChange={() => handleChangeCheckNew(dayIndex, index)}
                          color="primary"
                          inputProps={{
                            "aria-label": `${dayShort} checkbox`
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                ))}
              </Grid>
            </Grid>
            <Grid item xs={1}>
              <button
                id={index}
                onClick={handleDelete}
                className={classes.iconDelete}
              >
                <CloseIcon />
              </button>
            </Grid>
          </Grid>
        </Grid>
      )}
    </Draggable>
  );
};

export default Task;
